/* eslint no-restricted-syntax: 0 */
import { parse, format } from 'url';

import { Cookies } from '@confluence/cookies';

export const BRANCH_VERSION = 'useFrontendBranch';
export const BUILD_VERSION = 'useFrontendBuildVersion';
const BIFROST_OVERRIDE = 'bifrost-override';

export const exitBranchFn = () => {
	const urlComponents = parse(window.location.href, true);

	Cookies.remove(BIFROST_OVERRIDE);
	Cookies.remove(BRANCH_VERSION);
	Cookies.remove(BUILD_VERSION);

	window.location.assign(
		format({
			path: urlComponents.path,
			query: {
				...urlComponents.query,
				[BRANCH_VERSION]: 'off',
				[BUILD_VERSION]: 'off',
			},
			hash: urlComponents.hash,
		}),
	);
};

export const isBranchDeployFn = () => {
	let cookieBasedBranchVersion;

	const isBifrost = window.__IS_BIFROST__;
	let bifrostOverrideVersion;

	try {
		cookieBasedBranchVersion = Cookies.get(BRANCH_VERSION);
		if (isBifrost) {
			bifrostOverrideVersion = Cookies.get('bifrost-override');
		}
	} catch (err) {
		// Likely a firefox edge-case: "Error: can't access dead object"
		// Occasionally, document.cookie is cleaned up despite living
		// references -- including js-cookie's
		cookieBasedBranchVersion = 'off';
		if (isBifrost) {
			bifrostOverrideVersion = 'off';
		}
	}

	if (isBifrost) {
		return !!(bifrostOverrideVersion && !bifrostOverrideVersion.includes('CLASSIC-off-off'));
	}
	return !!(cookieBasedBranchVersion && cookieBasedBranchVersion !== 'off');
};
